import script from "./AlarmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmModal.vue?vue&type=script&setup=true&lang=js"

import "./AlarmModal.vue?vue&type=style&index=0&id=18a774e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a774e4"]])

export default __exports__